module.exports = __webpack_public_path__ + "img/ETH.b19c42e0.svg";